import { TIKTOK_URL_SCHEME } from "@/modules/helpers/tap-constants"
import { sendOpenLink } from "@/modules/helpers/utils"

export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    if (window.isSecureContext && navigator.clipboard) {
      await window.navigator.clipboard.writeText(text)
      return true
    }
    return false
  } catch (error) {
    console.error("Failed to copy to clipboard:", error)
    return false
  }
}

export const openTikTokAffiliateLink = (productLink: string): void => {
  try {
    const url = `${TIKTOK_URL_SCHEME}?bundle=url-add-product/template.js&channel=tea_selection_page&dynamic=1&hide_nav_bar=1&product_url=${productLink}`
    sendOpenLink(url)
  } catch (error) {
    console.error("Failed to open TikTok affiliate link:", error)
  }
}

export const formatPrice = (price: string | undefined): string => {
  if (!price) return ""
  if (typeof price === "number") return Number(price)?.toLocaleString() + "đ"
  return price.replaceAll(/[₫]/g, "") + "đ"
}

export const formatDiscount = (discount: string | undefined): string => {
  if (!discount) return ""
  return discount.replace("Save up to", "").replace("-", "")
}

export const formatCurrency = (number: number) =>
  new Intl.NumberFormat("vi-VN").format(Math.round(number)) + " đ"
